import { render } from "./LibroRojoView.vue?vue&type=template&id=58107c36&scoped=true"
import script from "./LibroRojoView.vue?vue&type=script&lang=js"
export * from "./LibroRojoView.vue?vue&type=script&lang=js"

import "./LibroRojoView.vue?vue&type=style&index=0&id=58107c36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58107c36"]])

export default __exports__